
import { HttpClient } from '@angular/common/http';
import { Component, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from "src/environments/environment";
import { MatSnackBar} from '@angular/material/snack-bar';
import { AuthenticationService } from 'src/app/_services';
import { first } from 'rxjs/operators';

@Component({
    selector: 'accounts-tab-7',
    templateUrl: './accounts-tab-7.html',
    styleUrls: [ './accounts.component.scss' ]
})
export class AccountsTab7 {

    seller_id : any;
    current_user : any;
    promocional : false;
    form: FormGroup;

    initialStatus: FormControl;

    loading: boolean = false;

    @Output() onSuccess = new EventEmitter();

    constructor(
        private httpClient: HttpClient,
        private snackBar: MatSnackBar,
        private autenticationService: AuthenticationService,
    ) {

        this.initialStatus = new FormControl('', [Validators.required]);

        this.form = new FormGroup({
            initialStatus: this.initialStatus,
        });
        this.current_user = this.autenticationService.currentUserValue
    }

    ngOnInit() {
        this.getDataSeller();
        this.asignarDatos();
        
    }

    public onSubmit() {
        if(!this.formIsValid()) {
            return;
        }

        this.loading = true;

        const initialStatus = this.initialStatus.value;

        this.httpClient.put(`${environment.apiUrl}/rmsfe/change_initial_status_devolution`, {
            initialStatus,
        }).subscribe(
            (response) => {
                this.snackBar.open('Se ha cambiado el estatus inicial de las devoluciones', 'Cerrar', {
                    duration: 2000,
                });
                this.getDataSeller();
            },
            (error) => {
                this.snackBar.open('Ha ocurrido un error al cambiar el estatus inicial de las devoluciones', 'Cerrar', {
                    duration: 2000,
                });
            },
            () => {
                this.loading = false;
            }
        );
    }
        guardar_promocional(){
            this.loading = true;
            const seller_id =  this.seller_id;
            const promocional = this.promocional;
            
            this.httpClient.post(`${environment.apiUrl}/rmsfe/actualizar_promocional_seller`, {
                seller_id,promocional
                
            }).subscribe(
                (response) => {
                    this.snackBar.open('Estatus de Promocional Actualizado', 'Cerrar', {
                        duration: 2000,
                    });
                    this.consultarDatos();
                },
                (error) => {
                    this.snackBar.open('Ha ocurrido un error al cambiar el estatus del  Promocional', 'Cerrar', {
                        duration: 2000,
                    });
                },
                () => {
                    this.loading = false;
                }
            );
        }
    public formIsValid() {
        return this.form.valid;
    }
    asignarDatos(){
        this.seller_id = this.current_user.seller_id;
        this.promocional = this.current_user.promocional;  
    }
      consultarDatos(){
        // console.log("entramos en consultarDatos");
        this.autenticationService.consultarUser()
        .pipe(first())
        .subscribe(
          data => {
            // console.log("regresamos de consultar user")
            // console.log(data)
            this.current_user = this.autenticationService.currentUserValue
            this.asignarDatos();
          },
          error => {
           // console.log("error 143")
       });
       
      }
    private getDataSeller(){
        this.autenticationService.consultarUser()
        .pipe(first())
        .subscribe(
          data => {
            this.initialStatus.setValue(data.initial_status_devolution);
             
            
          },
        );
    }
}